import { queryOptions } from "@tanstack/react-query";
import { POLL_MS, apiGet, apiPost } from "@amber/ui";
import {
  extensionPreviewSchema,
  extensionStartedSchema,
  historyWindowViewSchema,
  stateResultSchema,
} from "../../contracts/index";
import { collectionKeys } from "./keys";

export const historyQuery = queryOptions({
  queryKey: collectionKeys.history,
  queryFn: ({ signal }) => apiGet("/api/collection/history", historyWindowViewSchema, signal),
  refetchInterval: POLL_MS,
});

export const extensionPreviewQuery = (target: string, csrf: string | null) =>
  queryOptions({
    queryKey: collectionKeys.extensionPreview(target),
    queryFn: () => apiPost("/api/collection/history/preview", { target }, extensionPreviewSchema, csrf),
    staleTime: 10_000,
  });

export const historyCommands = {
  extend: (body: { target: string; reason: string }, csrf: string | null) =>
    apiPost("/api/collection/history/extensions", body, extensionStartedSchema, csrf),
  control: (
    id: string,
    action: "pause" | "resume" | "cancel",
    body: { reason: string; base_revision: number },
    csrf: string | null,
  ) => apiPost(`/api/collection/history/extensions/${encodeURIComponent(id)}/${action}`, body, stateResultSchema, csrf),
};
